var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:_vm.position},[_c('b-alert',{attrs:{"show":_vm.show,"variant":_vm.variant},on:{"dismissed":function($event){_vm.time=0}}},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }